// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SetupFee_DefaultInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import { registerContract } from './validate'

export interface SetupFee_DefaultInput {
currency?: string
provider_code?: string
amount_cents?: number
max_installments?: number
countries?: string[]
max_installments_by_country?: Record<string, number>
active?: boolean
}

registerContract('SetupFee_DefaultInput', {
  currency:                    { type: 'string',  required: false },
  provider_code:               { type: 'string',  required: false },
  amount_cents:                { type: 'number',  required: false },
  max_installments:            { type: 'number',  required: false },
  countries:                   { type: 'array',   required: false },
  max_installments_by_country: { type: 'object',  required: false },
  active:                      { type: 'boolean', required: false },
})
